export const SetInitialValue = (sustainability: boolean | null) => {
  if (sustainability === null) return null;
  return sustainability ? 0 : 1;
};
